import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

/**
 * Shared hook for fetching and managing accounts within a project.
 */
export const useProjectAccounts = (activeProject) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAccounts = useCallback(async () => {
    if (!activeProject?._id) return;
    setLoading(true);
    try {
      const res = await axios.get(`/api/projects/${activeProject._id}/accounts`);
      setAccounts(res.data);
    } catch (err) {
      console.error('Error fetching accounts:', err);
    } finally {
      setLoading(false);
    }
  }, [activeProject?._id]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  const addAccount = async (formData) => {
    try {
      const res = await axios.post(`/api/projects/${activeProject._id}/accounts`, formData);
      fetchAccounts();
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.msg || 'Error adding account' };
    }
  };

  const bankAccounts = accounts.filter(a => ['Bank', 'Credit Card'].includes(a.type));
  const plAccounts = accounts.filter(a => ['Income', 'Other Income', 'Cost of Goods Sold', 'Expense', 'Expenses', 'Other Expense'].includes(a.type));

  return {
    accounts,
    bankAccounts,
    plAccounts,
    loading,
    fetchAccounts,
    addAccount
  };
};
